import React, { useState, useEffect } from 'react';
import api from '../api';
import { useAuth } from './AuthContext';

const CourseManagement = ({ onBack }) => {
  const { currentUser } = useAuth();
  const [courses, setCourses] = useState([]);
  const [editingCourse, setEditingCourse] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchCourses = async () => {
      if (!currentUser?.id) {
        setCourses([]);
        setLoading(false);
        return;
      }

      try {
        const response = await api.get(`/courses/instructor/${currentUser.id}`);
        setCourses(Array.isArray(response.data?.data) ? response.data.data : []);
      } catch (error) {
        console.error('Error al cargar cursos del instructor:', error);
        setCourses([]);
      } finally {
        setLoading(false);
      }
    };

    fetchCourses();
  }, [currentUser?.id]);

  const handlePublish = async (courseId) => {
    try {
      const response = await api.put(`/courses/${courseId}/publish`);
      const updatedCourse = response.data?.data;

      if (!updatedCourse) {
        return;
      }

      setCourses((prevCourses) =>
        prevCourses.map((course) => course.id === courseId ? updatedCourse : course)
      );
    } catch (error) {
      console.error('Error al publicar curso:', error);
      alert(error.response?.data?.message || 'No se pudo publicar el curso.');
    }
  };

  const handleEdit = (course) => {
    setEditingCourse(course);
  };

  const handleSave = (updatedCourse) => {
    setCourses(courses.map(course =>
      course.id === updatedCourse.id ? updatedCourse : course
    ));
    setEditingCourse(null);
  };

  if (loading) {
    return <div className="text-center py-8">Cargando cursos...</div>;
  }

  return (
    <div className="bg-gray-100 min-h-screen">
      <div className="container mx-auto px-4 py-8">
        <button
          onClick={onBack}
          className="mb-4 px-4 py-2 bg-gray-200 rounded hover:bg-gray-300"
        >
          Volver al panel
        </button>

        <div className="bg-white rounded-lg shadow-sm overflow-hidden">
          <div className="p-6 border-b">
            <h2 className="text-2xl font-bold">Gestión de Cursos</h2>
          </div>
          <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
              <thead className="bg-gray-50">
                <tr>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Título</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estado</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Estudiantes</th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Acciones</th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200">
                {courses.map(course => (
                  <tr key={course.id}>
                    <td className="px-6 py-4 whitespace-nowrap">{course.title}</td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <span className={`px-2 py-1 text-xs rounded ${
                        course.status === 'published'
                          ? 'bg-green-100 text-green-800'
                          : 'bg-yellow-100 text-yellow-800'
                      }`}>
                        {course.status === 'published' ? 'Publicado' : 'Borrador'}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">{course.students}</td>
                    <td className="px-6 py-4 whitespace-nowrap space-x-2">
                      <button
                        onClick={() => handleEdit(course)}
                        className="text-blue-600 hover:text-blue-800"
                      >
                        Editar
                      </button>
                      {course.status !== 'published' && (
                        <button
                          onClick={() => handlePublish(course.id)}
                          className="text-green-600 hover:text-green-800"
                        >
                          Publicar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseManagement;
